// extracted by mini-css-extract-plugin
export default {"wrapper":"AppBar_wrapper__Ut-g+","section":"AppBar_section__9m-LZ","title":"AppBar_title__nh0UF"};